import { SkeletonListItems } from '@/components/List';
import ScanServicesListItem from './ScanServicesListItem';

export { ScanServicesListItem };

export type ScanServicesListProps = {
  isFetchingData?: boolean;
  wide?: boolean;
  className?: string;
  itemClassName?: string;
  serviceIds: number[];
  variant?: 'inline' | 'card';
  onOpen?: () => void;
};

export default function ScanServicesList({
  isFetchingData,
  wide,
  className,
  itemClassName,
  serviceIds,
  variant,
  onOpen,
}: ScanServicesListProps) {
  return (
    <div className={className}>
      {isFetchingData ? (
        <SkeletonListItems />
      ) : (
        serviceIds.map((id) => (
          <ScanServicesListItem
            key={id}
            wide={wide}
            className={itemClassName}
            serviceId={id}
            variant={variant}
            onOpen={onOpen}
          />
        ))
      )}
    </div>
  );
}
